import ICatalog_Item from "@models/ICatalog_Item";
import { useEffect, useMemo, useState } from "react";
import { OrderItemOption } from "./OrderItemOption/OrderItemOption";
import INewOrder_Item_Option from "@models/INewOrder_Item_Option";

type Props = {
    catalogItem: ICatalog_Item;
    selectedItemOptionsFn: (options: any) => void;
    flexDirection?: "flex-row" | "flex-column";
    /**
     * Existing values to pre-fill (edit flow). Only values whose item_option_id is one of the
     * catalog item's Options are kept; they are emitted through selectedItemOptionsFn on mount so
     * the parent sees them without the user touching anything.
     */
    initialValues?: Partial<INewOrder_Item_Option>[];
};

export const OrderItemOptions = (props: Props) => {
    const [orderItemOptions, setOrderItemOptions] = useState<Partial<INewOrder_Item_Option>[]>(() => {
        const optionIds = new Set((props.catalogItem.Options || []).map((option) => option.item_option_id));

        return (props.initialValues || [])
            .filter((value) => value.item_option_id !== undefined && optionIds.has(value.item_option_id))
            .map((value) => ({ item_option_id: value.item_option_id, value: value.value }));
    });

    useEffect(() => {
        // console.log("OrderItemOptions", orderItemOptions);

        props.selectedItemOptionsFn(orderItemOptions);
    }, [orderItemOptions]);

    const itemOptionsCount = useMemo(() => props.catalogItem.Options?.length || 0, [props.catalogItem.Options]);

    const selectedItemOptionsFn = (option: Partial<INewOrder_Item_Option>) => {
        const updatedOrderItemOptions = [...orderItemOptions];

        const existingOption = updatedOrderItemOptions.find((o) => o.item_option_id === option.item_option_id);

        if (existingOption) {
            existingOption.value = option.value;
        } else {
            updatedOrderItemOptions.push(option);
        }

        setOrderItemOptions(updatedOrderItemOptions);
    };

    return (
        <div className={"OrderItemOptions"}>
            {itemOptionsCount > 100 ? (
                <div>{/* Show Modal */}</div>
            ) : (
                <div className={`d-flex gap-2 ${props.flexDirection || "flex-row "}`}>
                    {props.catalogItem.Options?.map((option) => {
                        const initial = orderItemOptions.find((o) => o.item_option_id === option.item_option_id);

                        return (
                            <OrderItemOption
                                key={option.Item_Option?.id}
                                option={option}
                                selectedItemOptionFn={selectedItemOptionsFn}
                                initialValue={initial?.value !== undefined && initial?.value !== null ? String(initial.value) : undefined}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};
